import { IComponent, getV2ValueWP, tryParseJSON } from '@eventr/common'
import { useCallback } from 'react'
import { ComponentFinder } from '../componentFinder'

interface IShouldRenderProps {
    data: any
    renderOptions: IShouldRenderRenderOptions
    parentData?: any
    past?: boolean
}
interface IShouldRenderRenderOptions {
    components: IComponent[]
    conditions: ICondition[]
}
export interface ICondition {
    operator:
    | 'equal'
    | 'notEqual'
    | 'greaterThan'
    | 'lessThan'
    | 'greaterThanOrEqual'
    | 'lessThanOrEqual'
    | 'oneNotEmpty'
    | 'notEmpty'
    | 'empty'
    | 'notEmptyOrEmptyList'
    | 'inList'
    | 'labelIncludes'
    params: string[]
}
export const ShouldRender = ({
    data,
    renderOptions,
    parentData,
    past,
}: IShouldRenderProps) => {
    const shouldRender = useCallback(() => {
        let shouldRender = true
        renderOptions.conditions.forEach((c) => {
            switch (c.operator) {
                case 'equal':
                    if (
                        getV2ValueWP(c.params[0], data) !==
                        getV2ValueWP(c.params[1], data)
                    ) {
                        shouldRender = false
                    }
                    break
                case 'notEqual':
                    const paramsArray = c.params.slice(1)
                    const paramsResolvedArray = paramsArray.map((o) => {
                        return getV2ValueWP(o, data).toString()
                    })
                    if (
                        paramsResolvedArray.includes(
                            getV2ValueWP(c.params[0], data)
                        )
                    ) {
                        shouldRender = false
                    }
                    break
                case 'greaterThan':
                    if (
                        getV2ValueWP(c.params[0], data) <
                        getV2ValueWP(c.params[1], data)
                    ) {
                        shouldRender = false
                    }
                    break
                case 'lessThan':
                    if (
                        getV2ValueWP(c.params[0], data) >
                        getV2ValueWP(c.params[1], data)
                    ) {
                        shouldRender = false
                    }
                    break
                case 'greaterThanOrEqual':
                    if (
                        getV2ValueWP(c.params[0], data) <=
                        getV2ValueWP(c.params[1], data)
                    ) {
                        shouldRender = false
                    }
                    break
                case 'lessThanOrEqual':
                    if (
                        getV2ValueWP(c.params[0], data) >=
                        getV2ValueWP(c.params[1], data)
                    ) {
                        shouldRender = false
                    }
                    break
                case 'oneNotEmpty':
                    const onePresent = c.params.some((p) => {
                        const val = getV2ValueWP(p, data)
                        if (
                            val !== undefined &&
                            val !== null &&
                            val !== '' &&
                            val !== '[]' &&
                            val !== '{}'
                        ) {
                            return true
                        }
                        return false
                    })
                    shouldRender = onePresent
                    break
                case 'notEmpty':
                    const res = c.params.some((p) => {
                        const val = getV2ValueWP(p, data)
                        if (
                            val !== undefined &&
                            val !== null &&
                            val !== '' &&
                            val !== '[]' &&
                            val !== '{}'
                        ) {
                            return true
                        }
                        return false
                    })
                    shouldRender = res
                    break
                case 'empty':
                    const empty = c.params.every((p) => {
                        if (
                            getV2ValueWP(p, data) === undefined ||
                            getV2ValueWP(p, data) === null ||
                            getV2ValueWP(p, data) === ''
                        ) {
                            return true
                        }
                        return false
                    })
                    shouldRender = empty
                    break
                case 'notEmptyOrEmptyList':
                    const ans = c.params.some((p) => {
                        if (
                            getV2ValueWP(p, data) === undefined ||
                            getV2ValueWP(p, data) === null ||
                            getV2ValueWP(p, data) === '' ||
                            getV2ValueWP(p, data) === '[]'
                        ) {
                            return false
                        }
                        return true
                    })
                    shouldRender = ans
                    break
                case 'inList':
                    const list = tryParseJSON(
                        getV2ValueWP(c.params[0], data),
                        []
                    )
                    const optionArray = c.params.slice(2)

                    const present = list.some((element: any) => {
                        const optionResolvedArray = optionArray.map((o) => {
                            return getV2ValueWP(o, element).toString()
                        })

                        return optionResolvedArray.includes(
                            getV2ValueWP(c.params[1], element).toString()
                        )
                    })
                    shouldRender = present
                    break
                case 'labelIncludes':
                    shouldRender = false
                    for (const param of c.params) {
                        if (data && data.label && data.label.includes(param)) {
                            shouldRender = true
                        }
                    }
                    break
            }
        })
        return shouldRender
    }, [renderOptions, data])

    return (
        <>
            {shouldRender() &&
                renderOptions?.components.map((c, i) => {
                    return (
                        <ComponentFinder
                            key={i}
                            data={data}
                            renderOptions={c}
                            componentKey={c.componentKey}
                            parentData={parentData}
                            isInPast={past}
                        />
                    )
                })}
        </>
    )
}
